export default "__VITE_PUBLIC_ASSET__44b1f07d__"